import { SavedSearchResponse } from '@doda/api-client/aspida/@types';
import { FeaturedSearchConditionQuery } from 'components/SearchSideBar/types';
import { getKeyWordQuery, getCategoryQuery } from '../getKeywordQuery';

interface ArgumentType {
  savedSearchCondition?: SavedSearchResponse | undefined;
  featuredSearchCondition?: FeaturedSearchConditionQuery | undefined;
  keyWordQuery?: string | undefined;
  categoryQuery?: string | undefined;
}

/**
 * キーワードの初期値を取得
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.keyWordQuery クエリパラメータ
 * @returns キーワード
 */
export const getInitialIncludeKeywordText = ({
  savedSearchCondition,
  featuredSearchCondition,
  keyWordQuery,
}: ArgumentType) => {
  // 保存した検索条件
  if (savedSearchCondition)
    return savedSearchCondition.includedKeywordList
      ? savedSearchCondition.includedKeywordList.join(' ')
      : '';

  // 特集枠検索条件
  if (featuredSearchCondition)
    return featuredSearchCondition.includedKeyword
      ? featuredSearchCondition.includedKeyword.join(' ')
      : '';

  // クエリから取得した検索条件
  return getKeyWordQuery(keyWordQuery).join(' ');
};

/**
 * カテゴリーの初期値を取得
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.categoryQuery クエリパラメータ
 * @returns カテゴリー
 */
export const getInitialIncludeKeywordCategory = ({
  savedSearchCondition,
  featuredSearchCondition,
  categoryQuery,
}: ArgumentType) => {
  // 保存した検索条件
  if (savedSearchCondition)
    return savedSearchCondition.includedKeywordCategory ?? '1';

  // 特集枠検索条件
  if (featuredSearchCondition)
    return featuredSearchCondition.includedKeywordCategory ?? '1';

  // クエリから取得した検索条件
  return getCategoryQuery(categoryQuery) ?? '1';
};

/**
 * キーワードの初期値を取得
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.keyWordQuery クエリパラメータ
 * @returns キーワード
 */
export const getInitialExcludeKeywordText = ({
  savedSearchCondition,
  featuredSearchCondition,
  keyWordQuery,
}: ArgumentType) => {
  // 保存した検索条件
  if (savedSearchCondition)
    return savedSearchCondition.excludedKeywordList
      ? savedSearchCondition.excludedKeywordList.join(' ')
      : '';

  // 特集枠検索条件
  if (featuredSearchCondition)
    return featuredSearchCondition.excludedKeyword
      ? featuredSearchCondition.excludedKeyword.join(' ')
      : '';

  // クエリから取得した検索条件
  return getKeyWordQuery(keyWordQuery).join(' ');
};

/**
 * カテゴリーの初期値を取得
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.categoryQuery クエリパラメータ
 * @returns カテゴリー
 */
export const getInitialExcludeKeywordCategory = ({
  savedSearchCondition,
  featuredSearchCondition,
  categoryQuery,
}: ArgumentType) => {
  // 保存した検索条件
  if (savedSearchCondition)
    return savedSearchCondition.excludedKeywordCategory ?? '1';

  // 特集枠検索条件
  if (featuredSearchCondition)
    return featuredSearchCondition.excludedKeywordCategory ?? '1';

  // クエリから取得した検索条件
  return getCategoryQuery(categoryQuery) ?? '1';
};
